import { VoiceAgentAppConfigLayout } from 'Layouts/ApplicationsLayout/VoiceAgentConfigLayout'
import { SmsAgentConfigLayout } from 'Layouts/ApplicationsLayout/SmsAgentConfigLayout'
import { Component } from 'Layouts/ApplicationsLayout/AppHome'
import { Organisation } from 'Layouts/ApplicationsLayout/Organisation'
import ComingSoonLayout from 'Layouts/ComingSoonLayout'
import { CampaignComponentScope } from 'Models/Campaigns/Components/List/types'
import { Button, Result } from 'antd'
import { Link, createBrowserRouter } from 'react-router-dom'
import { SmsTemplateLayout } from 'Layouts/ApplicationsLayout/SmsTemplateLayout'

/*
lazy component will support exports having name Component
=> Alertnatively we can use this approach
async lazy() {
  let { AuthLayout } = await import('Layouts/AuthLayout')
  return { Component: AuthLayout }
}

=> To pass props use loader property and useLoader in component to read 
 */

const routes = createBrowserRouter([
  {
    path: '/login',
    lazy: () => import('../NewLogin'),
  },
  {
    path: '/demos',
    lazy: () => import('Pages/ExperienceCenter/Public/ExperienceCenterPublicPageLayout'),
    children: [
      {
        index: true,
        lazy: () => import('Pages/ExperienceCenter/Public/InboundExperienceLandingPage'),
      },
      {
        path: 'sms',
        lazy: () => import('Pages/ExperienceCenter/Public/SMSWebExperienceLandingPage'),
      },
      {
        path: 'call',
        lazy: () => import('Pages/ExperienceCenter/Public/CallTranscription'),
      },
    ],
  },
  {
    path: '/',
    lazy: () => import('Layouts/AuthLayout'),
    children: [
      {
        lazy: () => import('Layouts/ApplicationsLayout/AppHome'),
        children: [
          {
            index: true,
            lazy: () => import('../Organisation'),
          },
        ],
      },
      // {
      //   path: 'campaigns',
      //   children: [
      //     {
      // lazy: () => import('Layouts/ApplicationsLayout/AppHome'),
      //       children: [
      //         {
      //           index: true,
      //           loader: () => ({ scope: CampaignComponentScope.INDEPENDENT }),
      //           lazy: () => import('Pages/Campaign/List'),
      //         },
      //       ],
      //     },
      //   ],
      // },
      {
        path: 'campaigns-b',
        children: [
          {
            lazy: () => import('Layouts/ApplicationsLayout/AppHome'),
            children: [
              {
                path: 'journey',
                loader: () => ({ scope: CampaignComponentScope.INDEPENDENT }),
                lazy: () => import('Pages/CampaignC/List'),
              },
              {
                path: 'voice',
                loader: () => ({ scope: CampaignComponentScope.INDEPENDENT }),
                lazy: () => import('Pages/CampaignB/List/Voice'),
              },
              {
                path: 'sms',
                loader: () => ({ scope: CampaignComponentScope.INDEPENDENT }),
                lazy: () => import('Pages/CampaignB/List/Sms'),
              },
            ],
          },
          {
            path: ':campaign_uuid',
            children: [
              {
                path: 'batch',
                children: [
                  {
                    path: ':batch_uuid',
                    children: [
                      {
                        path: 'edit',
                        lazy: () => import('Pages/CampaignB/Edit'),
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      // {
      //   path: 'campaigns/create',
      //   lazy: () => import('Pages/Campaign/Create'),
      // },
      {
        path: 'campaigns-b/voice/create',
        lazy: () => import('Pages/CampaignB/Create/Voice'),
      },
      {
        path: 'campaigns-b/sms/create',
        lazy: () => import('Pages/CampaignB/Create/Sms'),
      },
      {
        path: 'campaigns-b/journey/create',
        lazy: () => import('Pages/CampaignC/Create'),
      },
      {
        path: 'campaigns-b/sms/create',
        lazy: () => import('Pages/CampaignB/Create/Sms'),
      },
      {
        path: 'campaigns-b/journey/create',
        lazy: () => import('Pages/CampaignC/Create'),
      },
      {
        path: 'clients/:organisation_uuid/voice-agents/:flow_uuid',
        children: [
          {
            path: 'agent',
            lazy: () => import('Pages/Agent'),
          },
        ],
      },
      // ---START--- **For backward compatibility, do not remove **
      {
        path: 'clients/:organisation_uuid/applications/:flow_uuid',
        children: [
          {
            path: 'agent',
            lazy: () => import('Pages/Agent'),
          },
        ],
      },
      // ---END--- **For backward compatibility, do not remove **
      {
        path: 'clients',
        children: [
          {
            lazy: () => import('Layouts/ApplicationsLayout/AppHome'),
            children: [
              {
                index: true,
                lazy: () => import('../Organisation'),
              },
            ],
          },
          {
            path: ':organisation_uuid',
            children: [
              {
                Component: Organisation,
                children: [
                  {
                    index: true,
                    lazy: () => import('../Applications/index'),
                  },
                ],
              },
              // {
              //   path: 'campaigns',
              //   children: [
              //     {
              //       Component: Organisation,
              //       children: [
              //         {
              //           index: true,
              // loader: () => ({ scope: CampaignComponentScope.ORGANISATION }),
              //           lazy: () => import('Pages/Campaign/List'),
              //         },
              //       ],
              //     },
              //   ],
              // },
              // {
              //   path: 'campaigns/create',
              //   lazy: () => import('Pages/Campaign/Create'),
              // },
              {
                path: 'campaigns-b',
                children: [
                  {
                    Component: Organisation,
                    children: [
                      {
                        path: 'journey',
                        loader: () => ({ scope: CampaignComponentScope.ORGANISATION }),
                        lazy: () => import('Pages/CampaignC/List'),
                      },
                      {
                        path: 'voice',
                        loader: () => ({ scope: CampaignComponentScope.ORGANISATION }),
                        lazy: () => import('Pages/CampaignB/List/Voice'),
                      },
                      {
                        path: 'sms',
                        loader: () => ({ scope: CampaignComponentScope.ORGANISATION }),
                        lazy: () => import('Pages/CampaignB/List/Sms'),
                      },
                    ],
                  },
                  {
                    path: ':campaign_uuid',
                    children: [
                      {
                        path: 'batch',
                        children: [
                          {
                            path: ':batch_uuid',
                            children: [
                              {
                                path: 'edit',
                                lazy: () => import('Pages/CampaignB/Edit'),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                path: 'campaigns-b/voice/create',
                lazy: () => import('Pages/CampaignB/Create/Voice'),
              },
              {
                path: 'campaigns-b/journey/create',
                lazy: () => import('Pages/CampaignC/Create'),
              },
              {
                path: 'campaigns-b/sms/create',
                lazy: () => import('Pages/CampaignB/Create/Sms'),
              },
              {
                path: 'account-manager',
                Component: Organisation,
                children: [
                  {
                    index: true,
                    lazy: () => import('Pages/AccountManager'),
                  },
                ],
              },
              {
                path: 'voice-agents',
                children: [
                  {
                    Component: Organisation,
                    children: [
                      {
                        index: true,
                        lazy: () => import('../Applications/index'),
                      },
                    ],
                  },
                  {
                    path: ':flow_uuid/calls/:call_uuid',
                    lazy: () => import('Pages/Applications/Calls/DetailedCallPage'),
                  },
                  {
                    Component: VoiceAgentAppConfigLayout,
                    path: ':flow_uuid',
                    children: [
                      {
                        index: true,
                        lazy: () => import('Pages/Applications/Details/Configuration'),
                      },
                      {
                        path: 'configuration',
                        lazy: () => import('Pages/Applications/Details/Configuration'),
                      },
                      {
                        path: 'integration',
                        lazy: () => import('Pages/Applications/Details/Integration'),
                      },
                      {
                        path: 'prompts',
                        lazy: () => import('Pages/Applications/Prompts'),
                      },
                      {
                        path: 'account',
                        element: <ComingSoonLayout title="Account" />,
                      },
                      {
                        path: 'analytics',
                        lazy: () => import('Pages/Analytics/ApplicationsAnalyticsDashboard'),
                      },
                      {
                        path: 'data-export',
                        lazy: () => import('Pages/Analytics/ApplicationsDataExportDashboard'),
                      },
                      {
                        path: 'data-export/:analytics_tab',
                        lazy: () => import('Pages/Analytics/ApplicationsDataExportDashboard'),
                      },
                      {
                        path: 'analytics/:analytics_tab',
                        lazy: () => import('Pages/Analytics/ApplicationsAnalyticsDashboard'),
                      },
                      {
                        path: 'calls',
                        lazy: () => import('Pages/Applications/Calls/CallsPage'),
                      },
                      {
                        path: 'control_panel',
                        element: <ComingSoonLayout title="Control Panel" />,
                      },
                      {
                        path: 'tcn_campaigns',
                        children: [
                          {
                            index: true,
                            lazy: () => import('Models/TCNCampaigns/List'),
                          },
                          {
                            path: 'list',
                            lazy: () => import('Models/TCNCampaigns/List'),
                          },
                        ],
                      },
                      {
                        path: 'batch-manager',
                        element: <ComingSoonLayout title="Batch Manager" />,
                      },
                      {
                        path: 'batch-rules',
                        element: <ComingSoonLayout title="Batch Rules" />,
                      },
                      {
                        path: 'dnd-manager',
                        element: <ComingSoonLayout title="DND Manager" />,
                      },
                      {
                        path: 'payment-fees',
                        element: <ComingSoonLayout title="Payment Fees" />,
                      },
                      {
                        path: 'settings',
                        lazy: () => import('Pages/Flows/Settings/ApplicationClientSettingsPage'),
                      },
                      // @e2e-experimental-testing
                      {
                        path: 'test',
                        lazy: () => import('../Flows/Test'),
                      },
                      {
                        path: 'test/:test_tab',
                        lazy: () => import('../Flows/Test'),
                      },
                    ],
                  },
                  {
                    path: ':flow_uuid/tcn_campaigns/create',
                    children: [
                      {
                        index: true,
                        lazy: () => import('../../Models/TCNCampaigns/Create'),
                      },
                      {
                        path: ':campaign_type',
                        lazy: () => import('../../Models/TCNCampaigns/Create'),
                      },
                    ],
                  },
                ],
              },
              // ---START--- **For backward compatibility, do not remove **
              {
                path: 'applications',
                children: [
                  {
                    Component: Organisation,
                    children: [
                      {
                        index: true,
                        lazy: () => import('../Applications/index'),
                      },
                    ],
                  },
                  {
                    path: ':flow_uuid/calls/:call_uuid',
                    lazy: () => import('Pages/Applications/Calls/DetailedCallPage'),
                  },
                  {
                    Component: VoiceAgentAppConfigLayout,
                    path: ':flow_uuid',
                    children: [
                      {
                        path: 'analytics',
                        lazy: () => import('Pages/Analytics/ApplicationsAnalyticsDashboard'),
                      },
                      {
                        path: 'analytics/:analytics_tab',
                        lazy: () => import('Pages/Analytics/ApplicationsAnalyticsDashboard'),
                      },
                      {
                        path: 'calls',
                        lazy: () => import('Pages/Applications/Calls/CallsPage'),
                      },
                    ],
                  },
                ],
              },
              // ---END--- **For backward compatibility, do not remove **
              {
                path: 'sms-agents',
                children: [
                  {
                    Component: Organisation,
                    children: [
                      {
                        index: true,
                        lazy: () => import('../Applications/SmsAgents'),
                        loader: () => ({ channel: 'SMS' }),
                      },
                    ],
                  },
                  {
                    path: ':flow_uuid/interactions/:interaction_uuid',
                    lazy: () => import('../Applications/SmsAgents/Monitor/SMSTranscriptReport'),
                  },
                  {
                    Component: SmsAgentConfigLayout,
                    path: ':flow_uuid',
                    children: [
                      {
                        index: true,
                        lazy: () => import('../Applications/SmsAgents/Configuration'),
                        loader: () => ({ channel: 'SMS' }),
                      },
                      {
                        path: 'configuration',
                        lazy: () => import('../Applications/SmsAgents/Configuration'),
                        loader: () => ({ channel: 'SMS' }),
                      },
                      {
                        path: 'interactions',
                        lazy: () => import('../Applications/SmsAgents/Monitor/SMSList'),
                        loader: () => ({ channel: 'SMS' }),
                      },
                      {
                        path: 'integration',
                        lazy: () => import('../Applications/SmsAgents/Integration'),
                        loader: () => ({ channel: 'SMS' }),
                      },
                      {
                        path: 'prompts',
                        lazy: () => import('../Home/Templates/sms/Prompts'),
                      },
                    ],
                  },
                ],
              },
              {
                path: 'email-agents',
                children: [
                  {
                    Component: Organisation,
                    children: [
                      {
                        index: true,
                        lazy: () => import('../Applications/SmsAgents'),
                        loader: () => ({ channel: 'EMAIL' }),
                      },
                    ],
                  },
                  {
                    Component: SmsAgentConfigLayout,
                    path: ':flow_uuid',
                    children: [
                      {
                        index: true,
                        lazy: () => import('../Applications/SmsAgents/Configuration'),
                        loader: () => ({ channel: 'EMAIL' }),
                      },
                      {
                        path: 'configuration',
                        lazy: () => import('../Applications/SmsAgents/Configuration'),
                        loader: () => ({ channel: 'EMAIL' }),
                      },
                      {
                        path: 'integration',
                        lazy: () => import('../Applications/SmsAgents/Integration'),
                        loader: () => ({ channel: 'EMAIL' }),
                      },
                      {
                        path: 'prompts',
                        lazy: () => import('../Home/Templates/email/Prompts'),
                      },
                    ],
                  },
                ],
              },
              {
                path: 'sms-template',
                children: [
                  {
                    Component: Organisation,
                    children: [
                      {
                        index: true,
                        lazy: () => import('../Applications/SmsAgents'),
                        loader: () => ({ channel: 'SMS' }),
                      },
                    ],
                  },
                  {
                    Component: SmsTemplateLayout,
                    path: ':flow_uuid',
                    children: [
                      {
                        index: true,
                        lazy: () => import('../Home/Templates/sms/Instructions'),
                      },
                      {
                        path: 'instructions',
                        lazy: () => import('../Home/Templates/sms/Instructions'),
                      },
                      {
                        path: 'prompts',
                        lazy: () => import('../Home/Templates/sms/Prompts'),
                      },
                      {
                        path: 'attributes',
                        lazy: () => import('../Home/Templates/sms/Attributes'),
                      },
                      {
                        path: 'settings',
                        lazy: () => import('../Home/Templates/sms/Settings'),
                      },
                    ],
                  },
                ],
              },
              {
                path: 'email-template',
                children: [
                  {
                    Component: Organisation,
                    children: [
                      {
                        index: true,
                        lazy: () => import('../Applications/SmsAgents'),
                        loader: () => ({ channel: 'SMS' }),
                      },
                    ],
                  },
                  {
                    Component: SmsTemplateLayout,
                    path: ':flow_uuid',
                    children: [
                      {
                        index: true,
                        lazy: () => import('../Home/Templates/sms/Instructions'),
                      },
                      {
                        path: 'instructions',
                        lazy: () => import('../Home/Templates/sms/Instructions'),
                      },
                      {
                        path: 'prompts',
                        lazy: () => import('../Home/Templates/sms/Prompts'),
                      },
                      {
                        path: 'attributes',
                        lazy: () => import('../Home/Templates/sms/Attributes'),
                      },
                      {
                        path: 'settings',
                        lazy: () => import('../Home/Templates/sms/Settings'),
                      },
                    ],
                  },
                ],
              },
              {
                path: 'templates',
                Component: Organisation,
                children: [
                  {
                    index: true,
                    lazy: () => import('../Home/Templates/OrganisationTemplatesPage'),
                  },
                ],
              },
              {
                path: 'audit-logs',
                Component: Organisation,
                children: [
                  {
                    index: true,
                    lazy: () => import('../AuditLogs'),
                  },
                ],
              },
              {
                path: 'users',
                Component: Organisation,
                children: [
                  { index: true, element: <ComingSoonLayout title="Users"></ComingSoonLayout> },
                ],
              },
              {
                path: 'settings',
                Component: Organisation,
                children: [
                  {
                    index: true,
                    lazy: () => import('Pages/ClientSettings/index'),
                  },
                  {
                    path: 'team/:user_id',
                    lazy: () => import('Pages/ClientSettings/Users/index'),
                  },
                  {
                    path: ':tab',
                    lazy: () => import('Pages/ClientSettings/index'),
                  },
                ],
              },
              {
                path: 'business-config/:type',
                Component: Organisation,
                children: [
                  {
                    index: true,
                    lazy: () => import('../BusinessConfig/index'),
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: 'templates',
        lazy: () => import('Layouts/ApplicationsLayout/AppHome'),
        children: [
          {
            path: 'voice',
            children: [
              {
                index: true,
                lazy: () => import('../Home/Templates/GlobalTemplatesPage'),
              },
              {
                path: ':template_uuid',
                lazy: () => import('Pages/Home/Templates/TemplateDetailsPage'),
              },
            ],
          },
          {
            path: 'email',
            children: [
              {
                index: true,
                lazy: () => import('../Home/Templates/email'),
              },
            ],
          },
          {
            path: 'sms',
            children: [
              {
                index: true,
                lazy: () => import('../Home/Templates/sms'),
              },
            ],
          },
        ],
      },
      {
        path: 'experience',
        element: <Component defaultCollapsed={true} />,
        children: [
          {
            index: true,
            lazy: () => import('Pages/ExperienceCenter/LandingPage'),
          },
        ],
      },
      {
        path: 'experience-center',
        element: <Component defaultCollapsed={true} />,
        children: [
          {
            index: true,
            lazy: () => import('Pages/ExperienceCenter/DemoGallery'),
          },
          {
            path: 'demo-gallery',
            lazy: () => import('Pages/ExperienceCenter/DemoGallery'),
          },
          {
            path: 'interactive-demos',
            lazy: () => import('Pages/ExperienceCenter/InteractiveDemos'),
          },
          {
            path: 'demo-users',
            lazy: () => import('Pages/ExperienceCenter/DemoUsers'),
          },
          {
            path: 'product-tour',
            element: <ComingSoonLayout title="Product Tour" />,
          },
          {
            path: 'settings',
            lazy: () => import('Pages/ExperienceCenter/Settings'),
          },
        ],
      },
    ],
  },
  {
    element: (
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button type="primary">
            <Link to="/">Go Home</Link>
          </Button>
        }
      />
    ),
    path: '*',
  },
])

export default routes
